import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-expansion-panel',
  standalone: false,
  templateUrl: './expansion-panel.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './expansion-panel.component.scss',
})
export class ExpansionPanelComponent {
  @Input() title: string = '';
  @Input() expanded: boolean = false;
  @Input() disabled: boolean = false;
  @Input() description: string = '';
  @Input() descriptionClasses: string | string[] = '';
  @Input() hideToggle: boolean = false;

  // Event emitted when the panel is opened
  @Output() opened = new EventEmitter<void>();
  onOpened() {
    this.opened.emit();
  }
}
